import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="vd-container py-32 text-center" data-testid="not-found-page">
      <p className="vd-eyebrow">404</p>
      <h1 className="mt-4 font-display text-5xl font-bold text-slate-900">
        Page not found
      </h1>
      <p className="mt-4 text-slate-600">
        The page you’re looking for doesn’t exist or has moved.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-8 inline-flex items-center gap-2 bg-slate-900 text-white px-5 py-3 rounded-md hover:bg-slate-800 transition-colors"
      >
        Return Home
      </Link>
    </section>
  );
}
